import React from "react";

export default function DeleteModal({ isOpen, onClose, onConfirm, title, deleteLoader }) {
  if (!isOpen) return null; // Don't render if modal is closed

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
      <div className="bg-white rounded-2xl shadow-lg p-6 w-full max-w-md">
        <h2 className="text-lg font-semibold text-gray-800">
          Confirm {title}
        </h2>
        <p className="mt-2 text-gray-600">
          Are you sure you want to {title} this item? This action cannot be undone.
        </p>

        <div className="mt-6 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
          >
            {deleteLoader && title == 'Remove' ?
              'Removing...' :
              deleteLoader && title == 'Delete' ? 
              'Deleting...' :
            title}
          </button>
        </div>
      </div>
    </div>
  );
}
